export default {
  post_search_result: 'Search result',
  post_conpy_url: 'Copy link',
  post_select_circle: 'Please select a circle first',
  post_uploading_publish: 'Attachment uploading. No content can be posted for now',
  post_pic_overrun: 'Upload failed. The number of images has exceeded the upper limit, please delete some and try again',
  post_Success_published: 'Posted successfully',
  post_fileList_limit: 'Up to {fileList, plural, =0 {no attachments} =1 {one attachment} other {# attachments}} can be uploaded',
  post_file_size_limit: 'Size of single file cannot exceed {fileSize}M',
  post_file_type_limit: 'Only files in PPT, WORD, EXCEL, PDF formats, images and zip packages can be uploaded. Please re-upload',
  post_Img_size_limit: 'Image size cannot exceed 3M. Please re-upload',
  post_Img_upload_seccess: 'Image uploaded successfully',
  post_no_circle_tip: 'You have not selected a circle. The corresponding contact cannot be found',
  post_had_click: 'You are a member of @',
  post_enter_title: 'Please enter the title in 1-20 words',
  post_add_circle: 'Add circle',
  post_enter_context: 'Please enter the body content in 5000 words',
  post_support_type: 'Files in PPT, WORD, EXCEL, PDF formats, images and zip packages can be uploaded',
  post_add_enclosure: 'Add file',
  post_publishing: 'Posting',
  post_publish: 'Post',
  post_upload_failed: 'Upload failed. The number of images has exceeded the upper limit, please delete some and try again'
}
